module.exports = __webpack_public_path__ + "static/media/1POLICY45.72387e4d.jpg";